import { JUST_WALLET } from '@/config'
import { WalletUtils } from '@/api/wallet/walletUtils'

/** 当前环境是否具备 DApp 钱包注入（以太坊 / Tron） */
export function isDappSupported() {
  if (typeof window === 'undefined') {
    return false
  }
  return (
    WalletUtils.isEthereumWalletAvailable() ||
    WalletUtils.isTronLinkAvailable()
  )
}

/**
 * 需要登录时的入口路径：
 * - JUST_WALLET：仅钱包，一律 /empty
 * - 否则：有 DApp 能力走 /empty，否则走账号登录页
 */
export function getAuthEntryPath() {
  if (JUST_WALLET) {
    return '/empty'
  }
  return isDappSupported() ? '/empty' : '/pass/login'
}

/** 未登录时允许访问的路径（除 OAuth 等白名单外） */
export function isAllowedPathWithoutLogin(path, dapp) {
  if (path === '/api/loginCallback/google') {
    return true
  }
  if (JUST_WALLET || dapp) {
    return path === '/empty'
  }
  return (
    path === '/pass/login' ||
    path === '/pass/register' ||
    path === '/pass/reset'
  )
}
